import { componentWithCondition } from "../../components/hoc/componentWithConditionCheck";
import { ModalUpdateBulkWrapper } from "../../../../../components/templates/modal/modal";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";

const SELECTION_REQUIRED_TOOLTIP = "Select one or more stock lines first.";

const InventoryDetailAction = ({ selectedOrderId }) => {
  const navigate = useNavigate();
  const bulkMovementRef = useRef(null);
  const bulkReclassifyRef = useRef(null);
  const hasSelection = selectedOrderId?.length > 0;

  const goStockAdjustment = () => {
    if (selectedOrderId.length > 0) {
      navigate("/inventory/detail/stock_adjustment_update", {
        state: { selectedIds: selectedOrderId },
      });
      return;
    }
    navigate("/inventory/detail/stock_adjustment");
  };

  return (
    <>
      <ModalUpdateBulkWrapper
        ref={bulkMovementRef}
        module="stock_movement"
        selectedIds={selectedOrderId}
      />
      <ModalUpdateBulkWrapper
        ref={bulkReclassifyRef}
        module="stock_reclassification"
        selectedIds={selectedOrderId}
      />
      <li className={`tableButton activeState`}>
        <button onClick={goStockAdjustment}>Stock Adjustment</button>
      </li>
      <li className={`tableButton ${hasSelection ? "activeState" : ""}`}>
        <button
          disabled={!hasSelection}
          title={hasSelection ? undefined : SELECTION_REQUIRED_TOOLTIP}
          onClick={() => bulkMovementRef.current?.setOpenBulkUpdateModal(true)}
        >
          Stock Movement
        </button>
      </li>
      <li className={`tableButton ${hasSelection ? "activeState" : ""}`}>
        <button
          disabled={!hasSelection}
          title={hasSelection ? undefined : SELECTION_REQUIRED_TOOLTIP}
          onClick={() => bulkReclassifyRef.current?.setOpenBulkUpdateModal(true)}
        >
          Stock Reclassify
        </button>
      </li>
    </>
  );
};

export const InventoryDetailActionWithCheck = componentWithCondition(InventoryDetailAction);
